import { Account } from "sharedFeatures/sharedModels";
import { ItemData } from "sharedGuiSmall/components";
import { Utils } from "./utils";

declare let SendJSError: any;

export class NavigationUtils {

    public static productCode = '4714343';
    //protected static alternativeProductCode = '32316946';
    public static alternativeProductCode = '4714343&ORDERSTYLE=nLWon5W5lLs=';
    public static singleTestProductCode = '44245310';

    public static geoBasedCurrencies: Array<ItemData> = [
        { id: 'GBP', value: '£ GBP', disabled: false },
        { id: 'USD', value: '$ USD', disabled: false },
        { id: 'CAD', value: '$ CAD', disabled: false },
        { id: 'AUD', value: '$ AUD', disabled: false },
        { id: 'EUR', value: '€ EUR', disabled: false }];

    public static currencies = new Map<string, string>([["GBP", "£"], ["USD", "$"], ["CAD", "$"], ["AUD", "$"], ["EUR", "€"]]);

    public static checkCompanyIds(account: Account, companyIds: string, caller: string) { 
        if (companyIds.length < 1) {
            console.log(`Buy link companyIds is null! - ${caller} for customerRef:${account.customerRef}/${account.externalCustomerRef}, userName:${account.UserName}`);
            SendJSError(
                "Buy link companyId is null!",
                `${caller} for customerRef:${account.customerRef}/${account.externalCustomerRef}, userName:${account.UserName}`,
                '',
                0,
                0,
                '',
                null
            );
        }
    }

    public static getCompanyIdForBuyLink(account: Account, caller: string): string {
        let result = Utils.getCookie('selectedCompanyIdForBuy');                    
        this.checkCompanyIds(account, result, caller);       

        return result;
    }

    public static openPaymentPage(
        account: Account,
        packageType: string,
        frequencyType: string,
        currencyCode: string,
        returnLink: string,
        productCode: string,
        productVersion: string,
        subscriptionRef: string = '',
        userCompanies: string = ''
    ): void {

        let link = account.pathToBrixxForecast;
        let pCode = productCode;
        
        this.checkCompanyIds(account, userCompanies, 'openPaymentPage()');
        if (userCompanies.length < 1)
            return;

        link = link.replace('CompanyID', userCompanies);

        link = link
            .replace('#{license}', subscriptionRef)
            .replace('package', packageType)
            .replace('frequency', frequencyType)
            .replace('cur', currencyCode)
            .replace('dcur', currencyCode)
            .replace("EMAIL=", "EMAIL=" + account.UserName)
            .replace('productCode', pCode)
            .replace('productVersion', productVersion)
            .replace('optCode', 'OPTIONS' + pCode);

        if (account.externalCustomerRef != '')
            link = link + "&CUSTOMERID=" + account.externalCustomerRef.toString();
        else if (account.customerRef != 0)
            link = link + "&AV_CUSTOMERID=" + account.customerRef.toString();

        link = link + "&REF=" + returnLink;
        document.cookie = `packageTypeUpgrade#${userCompanies}=${packageType}; path=/;`;
        
        window.open(link, '_self');

    }

    public static openChangePaymentPage(
        account: Account,
        packageType: string,
        frequencyType: string,
        currencyCode: string,
        returnLink: string,
        productCode: string,
        productVersion: string,
        subscriptionRef: string = '',
        companiesWithLicense: string = ''
    ): void {

        let link = account.pathToChangeLicense;
        let pCode = productCode;

        if (companiesWithLicense == '')
            companiesWithLicense = NavigationUtils.getCompanyIdForBuyLink(account, 'openChangePaymentPage()');
        if (companiesWithLicense.length < 1)
            return;

        link = link.replace('CompanyID', companiesWithLicense);

        link = link
            .replace('#{license}', subscriptionRef)
            .replace('package', packageType)
            .replace('frequency', frequencyType)
            .replace("EMAIL=", "EMAIL=" + account.UserName)
            .replace('productCode', pCode)
            .replace('productVersion', productVersion)
            .replace('cur', currencyCode)
            .replace('dcur', currencyCode);

        if (account.customerRef != 0)
            link = link + "&AV_CUSTOMERID=" + account.customerRef.toString();

        link = link + "&REF=" + returnLink;
        let selectedCompanyId = NavigationUtils.getCompanyIdForBuyLink(account, 'openChangePaymentPage()');  
        document.cookie = `packageTypeUpgrade#${selectedCompanyId}=${packageType}; path=/;`;        

        window.open(link, '_self');

    }


}
